var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "url(#paint0_linear_1_579)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0498 16.9101C30.1329 15.9842 29.0408 15.25 27.8373 14.7504C26.6338 14.2508 25.3429 13.9957 24.0398 14.0001C18.5798 14.0001 14.1298 18.4501 14.1298 23.9101C14.1298 25.6601 14.5898 27.3601 15.4498 28.8601L14.0498 34.0001L19.2998 32.6201C20.7498 33.4101 22.3798 33.8301 24.0398 33.8301C29.4998 33.8301 33.9498 29.3801 33.9498 23.9201C33.9498 21.2701 32.9198 18.7801 31.0498 16.9101ZM24.0398 32.1501C22.5598 32.1501 21.1098 31.7501 19.8398 31.0001L19.5398 30.8201L16.4198 31.6401L17.2498 28.6001L17.0498 28.2901C16.2274 26.9771 15.7907 25.4593 15.7898 23.9101C15.7898 19.3701 19.4898 15.6701 24.0298 15.6701C26.2298 15.6701 28.2998 16.5301 29.8498 18.0901C30.6174 18.8539 31.2257 19.7626 31.6394 20.7634C32.0531 21.7642 32.264 22.8371 32.2598 23.9201C32.2798 28.4601 28.5798 32.1501 24.0398 32.1501ZM28.5598 25.9901C28.3098 25.8701 27.0898 25.2701 26.8698 25.1801C26.6398 25.1001 26.4798 25.0601 26.3098 25.3001C26.1398 25.5501 25.6698 26.1101 25.5298 26.2701C25.3898 26.4401 25.2398 26.4601 24.9898 26.3301C24.7398 26.2101 23.9398 25.9401 22.9998 25.1001C22.2598 24.4401 21.7698 23.6301 21.6198 23.3801C21.4798 23.1301 21.5998 23.0001 21.7298 22.8701C21.8398 22.7601 21.9798 22.5801 22.0998 22.4401C22.2198 22.3001 22.2698 22.1901 22.3498 22.0301C22.4298 21.8601 22.3898 21.7201 22.3298 21.6001C22.2698 21.4801 21.7698 20.2601 21.5698 19.7601C21.3698 19.2801 21.1598 19.3401 21.0098 19.3301H20.5298C20.3598 19.3301 20.0998 19.3901 19.8698 19.6401C19.6498 19.8901 19.0098 20.4901 19.0098 21.7101C19.0098 22.9301 19.8998 24.1101 20.0198 24.2701C20.1398 24.4401 21.7698 26.9401 24.2498 28.0101C24.8398 28.2701 25.2998 28.4201 25.6598 28.5301C26.2498 28.7201 26.7898 28.6901 27.2198 28.6301C27.6998 28.5601 28.6898 28.0301 28.8898 27.4501C29.0998 26.8701 29.0998 26.3801 29.0298 26.2701C28.9598 26.1601 28.8098 26.1101 28.5598 25.9901Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_579",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60D669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72C078"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsappIcon.0895973f4f11d39ae639f5ca4ab2c169.svg";
export { ForwardRef as ReactComponent };